<template>
  <div class="Modal_primary">
    <Modal
      v-model="modalAlert"
      :styles="{top: '40%'}"
      :closable="false"
      :mask-closable="false"
      width="300"
    >
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ title }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ content }}</p>
      </div>
      <div slot="footer" style="text-align:center">
        <i-button type="primary" :loading="modal_loading" @click="$emit('makeSure')">确认</i-button>
        <i-button @click="$emit('cansel')">取消</i-button>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: {
    modalAlert: [String, Boolean],
    title: [String],
    content: [String],
    modal_loading: [Boolean]
  }
};
</script>